import React from 'react'
import { useState, useEffect } from "react";

const Home = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
    useEffect(() => {
      // fetch(`https://inshorts.deta.dev/news?category=all`)
      fetch(`https://newsapi.org/v2/top-headlines?country=in&apiKey=3d2b4d0a937c4a75817996e4416238d5`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `This is an HTTP error: The status is ${response.status}`
            );
          }
          return response.json();
        })
        .then((actualData) => {
          setData(actualData);
          setError(null);
          console.log("data is: "+ actualData);
          
        })
        .catch((err) => {
          setError(err.message);
          setData(null);
        })
        .finally(() => {
          setLoading(false);
        });
    }, []);

    console.log("data is: "+ JSON.stringify(data, undefined, "\t"));
  
    return (
      <div className="App">
        <span style={{fontSize: "2rem",lineHeight: "1.3333333333", fontWeight: 'bold'}}>DAILY <span style={{color:'#ff9600',fontSize: "2rem",lineHeight: "1.3333333333", fontWeight: 'bold'}}>NEWS</span></span>
        {loading && <div>A moment please...</div>}
        {error && (
          <div>{`There is a problem fetching the post data - ${error}`}</div>
        )}
        
        <ul>
          {data &&
            data.articles.map(({id,title,content,urlToImage, url }) => (
              <li key={content}>
                <div className='childs'>
                <div className='images'>
                <img src={urlToImage} alt="" />
                </div>
                <p>{title}</p>
                <a className='seePost' href={url}><button className='button'>Read More</button></a>
                </div>
                <br />
              </li>
            ))}
        </ul>
      </div>
    );
  
  }
  
export default Home